import { useQuery } from '@tanstack/react-query'
import { atom } from 'jotai'
import { useQueryParams } from 'ssr/router'
import { tagsFiltersOptions } from 'ui-components'

import { searchTags } from '~map-tags/api/searchTags'
import {
  Search_Tags_Sort,
  SearchTagsQueryVariables
} from '~map-tags/types/__generated/gql/graphql'

export function getSearchTagsQueryKey(variables) {
  return ['getSearchTags', variables]
}

export const atoms = {
  sort: atom(tagsFiltersOptions.popular),
  query: atom('')
}

type Query = {
  query?: string
  sort?: string
  page?: number
}

export const limit = 10

export function useSearchTags() {
  const queryParams = useQueryParams<Query>()
  const page = Number(queryParams.page) || 1

  const variables: SearchTagsQueryVariables = {
    from: (page - 1) * limit,
    size: limit,
    query: queryParams.query || '',
    sort: getSort(queryParams.sort)
  }

  const query = useQuery({
    queryKey: getSearchTagsQueryKey(variables),
    queryFn: () => searchTags(variables)
  })

  const pagination = {
    page,
    total: query.data?.total || 0,
    limit: limit
  }

  return { ...query, pagination }
}

const getSort = (sort) => {
  if (!sort) return Search_Tags_Sort.Popular

  if (!Object.values(Search_Tags_Sort).includes(sort))
    throw Error('Invalid sort value')

  return sort as Search_Tags_Sort
}
